import utilsType from './type.js'
/*
 * 数据校验类 by shw
 * @method resetData 重置数据
 * @method checkData 校验数据
 * @method checkComfirm 校验数据,且自动提示 返回promise , params[data] 需要校验的数据 params[message] 需要提示的语句
 */
class Verification {
	constructor (data) {
		this.resetData(data)
	}

	resetData (data) {
		this.origin = typeof data === 'object' ? utilsType.JSONcopy(data) : data
	}

	checkData (data) {
		return utilsType.compare(this.origin, data)
	}

	getOriginData () {
		return utilsType.deepClone(this.origin)
	}
}

export const fxDataVerification = function (origin) {
	return new Verification(origin)
}



// WEBPACK FOOTER //
// ./src/lib/util/src/verification.js